<template>
  <!-- Same alert as the Overview tab's notice, so an announcement looks like one. -->
  <div v-if="visible" class="print:hidden">
    <v-alert
      type="info"
      variant="tonal"
      density="compact"
      closable
      class="mb-4 mt-4 text-sm"
      data-cy="conflict-upgrade-notice"
      @click:close="dismiss"
    >
      <template #text>
        Conflict check has been upgraded: searches are more accurate, results
        are now split into full matches and partial matches, and you can save a
        check with your notes and find it later under Previous checks.
        <a
          :href="SUPPORT_URL"
          target="_blank"
          rel="noopener noreferrer"
          class="underline"
          data-cy="conflict-upgrade-link"
          >Learn what changed</a
        >
      </template>
    </v-alert>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const SUPPORT_URL =
  'https://support.leanlaw.co/conflict-checking-has-been-upgraded';

// Remembered, unlike the Overview notice's per-visit dismissal: this is an
// announcement, and one that reappears on every check stops being read. Versioned so a
// later announcement starts fresh rather than inheriting this dismissal.
const DISMISSED_KEY = 'conflictCheckUpgradeNotice.v2.dismissed';

function wasDismissed(): boolean {
  try {
    return localStorage.getItem(DISMISSED_KEY) === 'true';
  } catch {
    // Storage blocked (private mode, a locked-down browser): show the notice — never
    // lose the announcement because the preference could not be read.
    return false;
  }
}

const visible = ref(!wasDismissed());

function dismiss(): void {
  visible.value = false;
  try {
    localStorage.setItem(DISMISSED_KEY, 'true');
  } catch {
    // Storage blocked: the notice is gone for this visit and returns next time, which
    // is the worst this can do. Nothing to report to the reviewer.
  }
}
</script>
